import React from "react";
import investorHomeImage from "../../../assets/investor/investor-banner.png";
function CorporateHomeBanner() {
    return (
        <>
        <section
          className="investor-home-hero-section ih_hero_web"
          style={{
            backgroundImage: `url(${investorHomeImage})`,
          }}
        >
          <div className="title_container">
            <h1>Focused on <br />investor priorities, <br />always.</h1>
          </div>
        </section>

        {/* mobile view */}
        <div
          className="investor-home-hero-section ih_mob_web"
          style={{
            backgroundImage: `url(${investorHomeImage})`,
            position: "relative",
          }}
        >
          <div className="title_container">
            <p className="ih_mob_title">Focused on <br />investor priorities <br />always.</p>
          </div>
        </div>
        </>
    );
}

export default CorporateHomeBanner;